import { Application } from "@hotwired/stimulus"
import { registerControllers } from "stimulus-vite-helpers"

const application = Application.start()
window.Stimulus = application

// Alle *_controller.js in diesem Ordner (rekursiv) automatisch registrieren.
// Dateiname bestimmt den Identifier: ble_modal_controller.js -> "ble-modal", native/ble_controller.js -> "native--ble".
const controllers = import.meta.glob("./**/*_controller.js", { eager: true })
registerControllers(application, controllers)

// Global teardown
// https://www.betterstimulus.com/turbo/teardown
document.addEventListener("turbo:before-cache", () => {
  application.controllers.forEach((controller) => {
    if (typeof controller.beforeTurboCache === "function") {
      controller.beforeTurboCache()
    }
  })
})
